import { useDispatch } from "react-redux";
import { onChangePolicyCoveragePremiumDetails, setPolicyCoveragePremiumDetailsType } from "../../../../../features/ebam/plicy-data-page/policy-coverage-premium-details/policy-coverage-premium-details.slice";
import EditSaveCancelButtons from "../../../../ui/edit-save-cancel-buttons";
import Input from "../../../../ui/input";
import PolicyContentHeaderAction from "./policy-content-header-action";
import { usePolicyActions } from "../../../../../hooks/actions/use-policy-actions";
import { formatNumberWithComma } from "../../../../../utils/format-numbers.utils";
import { usePolicyDataState } from "../../../../../hooks/policy/use-policy-data-state";
import { useProposalTypeData } from "../../../../../hooks/proposal/use-proposal-type-data";

interface Props {
    isShow: boolean;
}

export default function PolicyScheduleTerminationAge({ isShow }: Props) {

    const { handleEditScheduleOfInsurance, isLoadingUpdatePolicy, handleCancelEditPolicySchedule } = usePolicyActions()
    const dispatch = useDispatch();
    const { isPCPTerminationAge, policyTerminationAge } = usePolicyDataState();
    const { basicPlan } = useProposalTypeData();
    
    if (!isShow) {
        return null;
    }

    return (
        <div className="border rounded text-xs">
            <div className='bg-[#eef6fc] border-b border-[#c7e0f3] px-3 py-2 text-left text-[#186cb2] sm:px-4 sm:py-2.5'>
                <div className="flex flex-row items-start justify-between gap-2 md:gap-4">
                    <PolicyContentHeaderAction
                        title='Termination Age'
                        subTitle='Specify the maximum age at which coverage terminates.'
                    />
                    <EditSaveCancelButtons
                        isEditing={!isPCPTerminationAge}
                        onEdit={() => dispatch(setPolicyCoveragePremiumDetailsType("terminationAge"))}
                        onCancel={handleCancelEditPolicySchedule}
                        onSave={() => handleEditScheduleOfInsurance('terminationAge')}
                        isLoading={isLoadingUpdatePolicy}
                    />
                </div>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:gap-5 md:grid-cols-2 px-3 py-2 sm:px-4">
                <div>
                    <Input
                        type='text'
                        name='plan'
                        value={basicPlan?.name ?? ''}
                        isCustomStyle={true}
                        customCss={`bg-gray-100 rounded border border-gray-300 block w-full text-xs px-2 py-1.5 outline-none`}
                        onChange={() => {}}
                        required={true}
                    />
                </div>
                <div className={`text-gray-600`}>
                    <div className={`flex border overflow-hidden rounded focus-within:border-[#186cb2] ${policyTerminationAge ? 'border-[#186cb2]' : 'border-gray-300'}`}>
                        <Input
                            type='text'
                            name='pTerminationsAge'
                            value={formatNumberWithComma(policyTerminationAge ?? '')}
                            isCustomStyle={true}
                            customCss={`rounded-tr rounded-br w-full text-xs px-2 py-1.5 outline-none ${!policyTerminationAge ? "" : "bg-[#186cb2]/10"}`}
                            onChange={(e) => {
                                const value = e.target.value.replace(/,/g, '');
                                dispatch(onChangePolicyCoveragePremiumDetails({
                                    field: 'terminationAge',
                                    value: value === '' ? null : Number(value)
                                }));
                            }}
                            required={true}
                            disabled={!isPCPTerminationAge || isLoadingUpdatePolicy}
                        />
                        <div className="w-28 shrink-0">
                            <div className="relative w-full">
                                <button className="w-full px-3 py-[6px] text-xs flex justify-between items-center bg-[#186cb2]/10 disabled:cursor-not-allowed" >
                                    <span className="font-bold text-left">
                                        years old
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
